/* eslint-disable no-case-declarations */
/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import _ from 'lodash';
import { useTranslator } from '@jutro/locale';
import MLAdditionalLocationNotRentedComponent from '../MLAdditionalLocationNotRentedComponent/MLAdditionalLocationNotRentedComponent';
import MLExcludedPrivateStucturesComponent from '../MLExcludedPrivateStucturesComponent/MLExcludedPrivateStucturesComponent';
import MLSpecificStructureOffPremisesComponent from '../MLSpecificStructureOffPremisesComponent/MLSpecificStructureOffPremisesComponent';
import MLHOExcludedAnimalLiabilitiesComponent from '../MLHOExcludedAnimalLiabilitiesComponent/MLHOExcludedAnimalLiabilitiesComponent';
import MLHOBusinessScheduleItemsComponent from '../MLHOBusinessScheduleItemsComponent/MLHOBusinessScheduleItemsComponent';
import MLHOValuableItemsUnspecifiedScheduledItemsComponent from '../MLHOValuableItemsUnspecifiedScheduledItemsComponent/MLHOValuableItemsUnspecifiedScheduledItemsComponent';
import MLHOHomeBusinessComponent from '../MLHOHomeBusinessComponent/MLHOHomeBusinessComponent';
import MLHOBusinessPursuitsLiabilityInsComponent from '../MLHOBusinessPursuitsLiabilityInsComponent/MLHOBusinessPursuitsLiabilityInsComponent';
import MLHOAdditionalHomeLiabilityComponent from '../MLHOAdditionalHomeLiabilityComponent/MLHOAdditionalHomeLiabilityComponent';
import MLHOFarmOrRanchScheduledItemsComponent from '../MLHOFarmOrRanchScheduledItemsComponent/MLHOFarmOrRanchScheduledItemsComponent';
import MLHOLiabilityForFarmlandLeasedComponent from '../MLHOLiabilityForFarmlandLeasedComponent/MLHOLiabilityForFarmlandLeasedComponent';
import MLHOHobbyFarmScheduledItemsComponent from '../MLHOHobbyFarmScheduledItemsComponent/MLHOHobbyFarmScheduledItemsComponent';
import MLHOSeparateStructsNotRentedComponent from '../MLHOSeparateStructsNotRentedComponent/MLHOSeparateStructsNotRentedComponent';
import MLHOSeparateStructsRentedComponent from '../MLHOSeparateStructsRentedComponent/MLHOSeparateStructsRentedComponent';
import MLHOSeparateStructsAwayFromResidenceComponent from '../MLHOSeparateStructsAwayFromResidenceComponent/MLHOSeparateStructsAwayFromResidenceComponent';
import MLHOValuableItemsSpecifiedComponent from '../MLHOValuableItemsSpecifiedComponent/MLHOValuableItemsSpecifiedComponent';
import MLHOSeparateStructureExclusionComponent from '../MLHOSeparateStructureExclusionComponent/MLHOSeparateStructureExclusionComponent';
import MLHOOtherStructureExclusionComponent from '../MLHOOtherStructureExclusionComponent/MLHOOtherStructureExclusionComponent';
import MLPUPAnimalLiabilityExclusionsComponent from '../MLPUPAnimalLiabilityExclusionsComponent/MLPUPAnimalLiabilityExclusionsComponent';
import MLPUPExcludedLocationsComponent from '../MLPUPExcludedLocationsComponent/MLPUPExcludedLocationsComponent';
import MLPUPBusinessActivitiesComponent from '../MLPUPBusinessActivitiesComponent/MLPUPBusinessActivitiesComponent';
import MLPUPExcludedWatercraftsComponent from '../MLPUPExcludedWatercraftsComponent/MLPUPExcludedWatercraftsComponent';
import metadata from './MLClauseScheduledItemsComponent.metadata.json5';
import styles from './MLClauseScheduledItemsComponent.module.scss';
import messages from './MLClauseScheduledItemsComponent.messages';

const BUSINESS_PURSUITS_TYPE = 'businessPursuits';
const INCIDENTAL_BUSINESS_TYPE = 'incidentalBusinessWithinHome';
const VALUABLE_ITEMS_UNSPECIFIED_TYPE = 'valuableItemsUnspecified';
const HOME_BUSINESS_TYPE = 'homeBusiness';
const BUSINESS_PURSUITS_LIABILITY_TYPE = 'businessPursuitsLiabilityInsEmp';
const ADDITIONAL_HOME_LIABILITY_TYPE = 'additionalHomeLiability';
const LIABILITY_FOR_FARMLAND_LEASED = 'liabilityForFarmlandLeased';
const FARM_OR_RANCH_TYPE = 'farmOrRanchScheduledItems';
const HOBBY_FARM_TYPE = 'hobbyFarmScheduledItems';
const SEPARATE_STRUCTS_NOT_RENTED_TYPE = 'separateStructsNotRented';
const SEPARATE_STRUCTS_RENTED_TYPE = 'separateStructsRented';
const SEPARATE_STRUCTS_AWAY_FROM_RESIDENCE_TYPE = 'separateStructsAwayFromResidence';
const VALUABLE_ITEMS_SPECIFIED_TYPE = 'valuableItemsSpecified';
const SEPARATE_STRUCTURE_EXCLUSION_TYPE = 'separateStructureExclusion_Ext';
const OTHER_STRUCTURE_EXCLUSION_TYPE = 'otherStructureExclusion_Ext';

function MLClauseScheduledItemsComponent(props) {
    const {
        clause,
        onCovChange,
        onGeneralChange,
        loading,
        readOnly,
        isModernProduct,
        isNotDwellingPolicy
    } = props;

    const translator = useTranslator();


    // HO SchedItems
    const additionalLocationNotRented = _.get(clause, 'scheduledItems_ML.additionalLocationNotRented');
    const incidentalBusinessWithinHome = _.get(clause, 'scheduledItems_ML.incidentalBusinessWithinHome');
    const businessPursuits = _.get(clause, 'scheduledItems_ML.businessPursuits');
    const specificStructuresOffPremises = _.get(clause, 'scheduledItems_ML.specificStructuresOffPremises');
    const excludedAnimalLiabilities = _.get(clause, 'scheduledItems_ML.excludedAnimalLiabilities');
    const excludedPrivateStructures = _.get(clause, 'scheduledItems_ML.excludedPrivateStructures');
    const valuableItemsUnspecified = _.get(clause, 'scheduledItems_ML.valuableItemsUnspecified');
    const homeBusinessItems = _.get(clause, 'scheduledItems_ML.homeBusiness');
    const businessPursuitsLiabilityInsEmpItems = _.get(clause, 'scheduledItems_ML.businessPursuitsLiabilityInsEmp');
    const additionallHomeLiabilityItems = _.get(clause, 'scheduledItems_ML.additionallHomeLiability');
    const liabilityForFarmlandLeasedItems = _.get(clause, 'scheduledItems_ML.liabilityForFarmlandLeased');
    const farmOrRanchScheduledItems = _.get(clause, 'scheduledItems_ML.farmOrRanchScheduledItems');
    const hobbyFarmScheduledItems = _.get(clause, 'scheduledItems_ML.hobbyFarmScheduledItems');
    const separateStructsNotRented = _.get(clause, 'scheduledItems_ML.separateStructsNotRented');
    const separateStructsRented = _.get(clause, 'scheduledItems_ML.separateStructsRented');
    const separateStructsAwayFromResidence = _.get(clause, 'scheduledItems_ML.separateStructsAwayFromResidence');
    const separateStructureExclusionItems = _.get(clause, 'scheduledItems_ML.separateStructureExclusion_Ext');
    const otherStructureExclusionItems = _.get(clause, 'scheduledItems_ML.otherStructureExclusion_Ext');
    const valuableItemsSpecified = _.get(clause, 'scheduledItems_ML.valuableItemsSpecified');

    // Default HO ScheduledItems
    const defaultAdditionalLocationNotRented = _.get(clause, 'scheduledItems_ML.defaultAdditionalLocationNotRented');
    const defaultSpecifcStructureOffPremise = _.get(clause, 'scheduledItems_ML.defaultSpecificStructuresOffPremises');
    const defaultBusinessPursuits = _.get(clause, 'scheduledItems_ML.defaultBusinessPursuits');
    const defaultIncidentalBusinessWithinHome = _.get(clause, 'scheduledItems_ML.defaultIncidentalBusinessWithinHome');
    const defaultValuableItemsUnspecified = _.get(clause, 'scheduledItems_ML.defaultValuableItemsUnspecified');
    const defaultHomeBusiness = _.get(clause, 'scheduledItems_ML.defaultHomeBusiness');
    const defaultBusinessPursuitsLiabilityInsEmpItems = _.get(clause, 'scheduledItems_ML.defaultBusinessPursuitsLiabilityInsEmp');
    const defaultAdditionallHomeLiability = _.get(clause, 'scheduledItems_ML.defaultAdditionallHomeLiability');
    const defaultLiabilityForFarmlandLeased = _.get(clause, 'scheduledItems_ML.defaultLiabilityForFarmlandLeased');
    const defaultFarmOrRanchScheduledItem = _.get(clause, 'scheduledItems_ML.defaultFarmOrRanchScheduledItem');
    const defaultHobbyFarmScheduledItem = _.get(clause, 'scheduledItems_ML.defaultHobbyFarmScheduledItem');
    const defaultSeparateStructsNotRented = _.get(clause, 'scheduledItems_ML.defaultSeparateStructsNotRented');
    const defaultSeparateStructsRented = _.get(clause, 'scheduledItems_ML.defaultSeparateStructsRented');
    const defaultSeparateStructsAwayFromResidence = _.get(clause, 'scheduledItems_ML.defaultSeparateStructsAwayFromResidence');
    const defaultSeparateStructureExclusion = _.get(clause, 'scheduledItems_ML.defaultSeparateStructureExclusion_Ext');
    const defaultOtherStructureExclusion = _.get(clause, 'scheduledItems_ML.defaultOtherStructureExclusion_Ext');
    const defaultValuableItemsSpecified = _.get(clause, 'scheduledItems_ML.defaultValuableItemsSpecified');

    // PUP Scheduled Items
    const pupAnimalLiabilityExclusions = _.get(clause, 'scheduledItems_ML.animalLiabilityExclusions');
    const pupMotorVehicles = _.get(clause, 'scheduledItems_ML.motorVehicles');
    const pupRecreationalExcludedVehicles = _.get(clause, 'scheduledItems_ML.recreationalExcludedVehicles');
    const pupExcludedLocations = _.get(clause, 'scheduledItems_ML.excludedLocations');
    const pupBusinessActivities = _.get(clause, 'scheduledItems_ML.businessActivities');
    const pupExcludedWatercrafts = _.get(clause, 'scheduledItems_ML.excludedWatercrafts');

    const getSchedItemsOfType = useCallback((type) => _.get(clause, `scheduledItems_ML.${type}`), [clause]);

    const resetChosenTermAndChosenTermValue = (schedItem) => {
        const copyOfSched = _.cloneDeep(schedItem);
        const keys = Object.keys(copyOfSched);
        keys.forEach((k) => {
            // eslint-disable-next-line no-prototype-builtins
            if (copyOfSched[k].hasOwnProperty('chosenTerm')) {
                copyOfSched[k].chosenTerm = null;
                copyOfSched[k].chosenTermValue = '';
            }
        });
        return copyOfSched;
    };

    const formatOptionAvailableVals = useCallback((options) => {
        if (!options) return [];
        return options.map((opt) => ({
            code: opt.code,
            name: {
                id: opt.code,
                defaultMessage: opt.name
            }
        }));
    }, []);

    const addItemSaveHandler = useCallback((vm, schedItemType) => {
        const schedItems = getSchedItemsOfType(schedItemType);
        if (vm.aspects.valid && vm.aspects.subtreeValid) {
            schedItems.push(vm.value);
            onCovChange(undefined, undefined, undefined, true);
            return true;
        }
        return false;
    }, [getSchedItemsOfType, onCovChange]);

    const editItemSaveHandler = useCallback((vm, schedItemType) => {
        const schedItems = getSchedItemsOfType(schedItemType);
        const indexOfCurrentItem = schedItems.findIndex((e) => {
            // Need to check for both fixedID and fixedId due to DTOs having different fixedId property names
            return (!_.isUndefined(e.fixedId) && e.fixedId === _.get(vm, 'fixedId.value'))
                || (!_.isUndefined(e.fixedID) && e.fixedID === _.get(vm, 'fixedID.value'));
        });
        if (vm.aspects.valid && vm.aspects.subtreeValid && indexOfCurrentItem !== -1) {
            schedItems[indexOfCurrentItem] = vm.value;
            onCovChange(undefined, undefined, undefined, true);
            return true;
        }
        return false;
    }, [getSchedItemsOfType, onCovChange]);


    const addressFormatter = (address) => `${address.addressLine1}, ${address.addressLine2 ? address.addressLine2 : ''}, ${address.city}, ${address.state}, ${address.zipCode}`;

    const addressFormatterForFarmLand = (address) => `${address.addressLine1 ? address.addressLine1 : ''}, ${address.addressLine2 ? address.addressLine2 : ''}, ${address.city ? address.city : ''}, ${address.state ? address.state : ''}, ${address.zipCode ? address.zipCode : ''}`;


    const addressFormatterTermState = (address) =>
        `${address.addressLine1 ? address.addressLine1 : ''}, 
        ${address.addressLine2 ? address.addressLine2 : ''}, 
        ${address.city ? address.city : ''}, 
        ${address.state.chosenTermValue ? address.state.chosenTermValue : ''}, 
        ${address.zipCode ? address.zipCode : ''}`;

    const removeItemHandler = useCallback((index, schedItemType) => {
        const schedItems = getSchedItemsOfType(schedItemType);
        schedItems.splice(index, 1);
        onCovChange(undefined, undefined, undefined, true);
    }, [getSchedItemsOfType, onCovChange]);

    const getTypeKeyDescription = (typeKeyName) => {
        return translator({
            id: typeKeyName,
            defaultMessage: typeKeyName
        });
    };

    const getYesNoAnswer = (val) => (val ? translator(messages.yes) : translator(messages.no));


    const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: {
            mladditionallocationnotrentedcomponent: MLAdditionalLocationNotRentedComponent,
            mlexcludedprivatestructurescomponent: MLExcludedPrivateStucturesComponent,
            mlspecificstructureoffpremisescomponent: MLSpecificStructureOffPremisesComponent,
            mlhoexcludedanimalliabilitiescomponent: MLHOExcludedAnimalLiabilitiesComponent,
            mlhobusinessscheduleitemscomponent: MLHOBusinessScheduleItemsComponent,
            mlpupanimalliabilityexclusionscomponent: MLPUPAnimalLiabilityExclusionsComponent,
            mlpupexcludedlocationscomponent: MLPUPExcludedLocationsComponent,
            mlpupbusinessactivitiescomponent: MLPUPBusinessActivitiesComponent,
            mlpupexcludedwatercraftscomponent: MLPUPExcludedWatercraftsComponent,
            mlhovaluableitemsunspecifiedscheduleditemscomponent: MLHOValuableItemsUnspecifiedScheduledItemsComponent,
            mlhohomebusinessscheduleitemscomponent: MLHOHomeBusinessComponent,
            mlhobusinesspursuitsliabilitycomponent: MLHOBusinessPursuitsLiabilityInsComponent,
            mlhoadditionalhomeliabilitycomponent: MLHOAdditionalHomeLiabilityComponent,
            mlhofarmorranchscheduleditemscomponent: MLHOFarmOrRanchScheduledItemsComponent,
            mlholiabilityforfarmlandleasedcomponent: MLHOLiabilityForFarmlandLeasedComponent,
            mlhohobbyfarmscheduleditemscomponent: MLHOHobbyFarmScheduledItemsComponent,
            mlseparatestructsnotrentedcomponent: MLHOSeparateStructsNotRentedComponent,
            mlseparatestructsrentedcomponent: MLHOSeparateStructsRentedComponent,
            mlseparatestructsawayfromresidencecomponent: MLHOSeparateStructsAwayFromResidenceComponent,
            mlseparatestructureexclusioncomponent: MLHOSeparateStructureExclusionComponent,
            mlotherstructureexclusioncomponent: MLHOOtherStructureExclusionComponent,
            mlhovaluableitemsspecifiedcomponent: MLHOValuableItemsSpecifiedComponent
        }
    };

    const overrides = {
        hoAdditionalLocationNotRented: {
            visible: !_.isUndefined(additionalLocationNotRented),
            items: additionalLocationNotRented,
            defaultItem: defaultAdditionalLocationNotRented,
            readOnly,
            loading,
            parentAddItemSaveHandler: addItemSaveHandler,
            parentEditItemSaveHandler: editItemSaveHandler,
            parentRemoveItemHandler: removeItemHandler,
            addressFormatter,
            resetChosenTermAndChosenTermValue,
            formatOptionAvailableVals
        },
        hoExcludedPrivateStructures: {
            visible: !_.isUndefined(excludedPrivateStructures),
            items: excludedPrivateStructures,
            readOnly,
            loading,
            parentAddItemSaveHandler: addItemSaveHandler,
            parentEditItemSaveHandler: editItemSaveHandler,
            parentRemoveItemHandler: removeItemHandler,
            addressFormatter
        },
        hoSpecificStructuresOffPremises: {
            visible: !_.isUndefined(specificStructuresOffPremises),
            items: specificStructuresOffPremises,
            defaultItem: defaultSpecifcStructureOffPremise,
            readOnly,
            loading,
            parentAddItemSaveHandler: addItemSaveHandler,
            parentEditItemSaveHandler: editItemSaveHandler,
            parentRemoveItemHandler: removeItemHandler,
            addressFormatter,
            resetChosenTermAndChosenTermValue,
            formatOptionAvailableVals
        },
        hoExclAnimalLiabilities: {
            visible: !_.isUndefined(excludedAnimalLiabilities),
            items: excludedAnimalLiabilities,
            readOnly
        },
        hoBusinessPursuits: {
            visible: !_.isUndefined(businessPursuits),
            schedItemType: BUSINESS_PURSUITS_TYPE,
            items: businessPursuits,
            defaultItem: defaultBusinessPursuits,
            readOnly,
            loading,
            parentRemoveItemHandler: removeItemHandler,
            resetChosenTermAndChosenTermValue,
            formatOptionAvailableVals,
            onCovChange
        },
        hoIncidentalBusiness: {
            visible: !_.isUndefined(incidentalBusinessWithinHome),
            schedItemType: INCIDENTAL_BUSINESS_TYPE,
            items: incidentalBusinessWithinHome,
            defaultItem: defaultIncidentalBusinessWithinHome,
            readOnly,
            loading,
            parentRemoveItemHandler: removeItemHandler,
            resetChosenTermAndChosenTermValue,
            formatOptionAvailableVals,
            onCovChange
        },
        hoValuableItemsUnspecified: {
            visible: !_.isUndefined(valuableItemsUnspecified),
            schedItemType: VALUABLE_ITEMS_UNSPECIFIED_TYPE,
            items: valuableItemsUnspecified,
            defaultItem: defaultValuableItemsUnspecified,
            readOnly,
            loading,
            parentRemoveItemHandler: removeItemHandler,
            resetChosenTermAndChosenTermValue,
            formatOptionAvailableVals,
            onCovChange
        },
        hoHomeBusiness: {
            visible: !_.isUndefined(homeBusinessItems),
            schedItemType: HOME_BUSINESS_TYPE,
            items: homeBusinessItems,
            defaultItem: defaultHomeBusiness,
            readOnly,
            loading,
            parentAddItemSaveHandler: addItemSaveHandler,
            parentEditItemSaveHandler: editItemSaveHandler,
            parentRemoveItemHandler: removeItemHandler,
            addressFormatter,
            resetChosenTermAndChosenTermValue,
            formatOptionAvailableVals,
            isNotDwellingPolicy
        },
        hoBusinessPursuitsLiabilityInsEmpItems: {
            visible: !_.isUndefined(businessPursuitsLiabilityInsEmpItems),
            schedItemType: BUSINESS_PURSUITS_LIABILITY_TYPE,
            items: businessPursuitsLiabilityInsEmpItems,
            defaultItem: defaultBusinessPursuitsLiabilityInsEmpItems,
            readOnly,
            loading,
            parentRemoveItemHandler: removeItemHandler,
            resetChosenTermAndChosenTermValue,
            formatOptionAvailableVals,
            onCovChange
        },
        hoAdditionalHomeLiabilityItems: {
            visible: !_.isUndefined(additionallHomeLiabilityItems),
            schedItemType: ADDITIONAL_HOME_LIABILITY_TYPE,
            items: additionallHomeLiabilityItems,
            defaultItem: defaultAdditionallHomeLiability,
            readOnly,
            loading,
            parentAddItemSaveHandler: addItemSaveHandler,
            parentEditItemSaveHandler: editItemSaveHandler,
            parentRemoveItemHandler: removeItemHandler,
            addressFormatter: addressFormatterTermState,
            resetChosenTermAndChosenTermValue,
            formatOptionAvailableVals
        },
        hoFarmOrRanchItems: {
            visible: !_.isUndefined(farmOrRanchScheduledItems),
            schedItemType: FARM_OR_RANCH_TYPE,
            items: farmOrRanchScheduledItems,
            defaultItem: defaultFarmOrRanchScheduledItem,
            readOnly,
            loading,
            parentAddItemSaveHandler: addItemSaveHandler,
            parentEditItemSaveHandler: editItemSaveHandler,
            parentRemoveItemHandler: removeItemHandler,
            addressFormatter,
            resetChosenTermAndChosenTermValue,
            formatOptionAvailableVals
        },
        hoLiabilityForFarmlandLeasedItems: {
            visible: !_.isUndefined(liabilityForFarmlandLeasedItems),
            schedItemType: LIABILITY_FOR_FARMLAND_LEASED,
            items: liabilityForFarmlandLeasedItems,
            defaultItem: defaultLiabilityForFarmlandLeased,
            readOnly,
            loading,
            parentAddItemSaveHandler: addItemSaveHandler,
            parentEditItemSaveHandler: editItemSaveHandler,
            parentRemoveItemHandler: removeItemHandler,
            addressFormatter : addressFormatterForFarmLand,
            resetChosenTermAndChosenTermValue,
            formatOptionAvailableVals
        },
        hoHobbyFarmItems: {
            visible: !_.isUndefined(hobbyFarmScheduledItems),
            schedItemType: HOBBY_FARM_TYPE,
            items: hobbyFarmScheduledItems,
            defaultItem: defaultHobbyFarmScheduledItem,
            readOnly,
            loading,
            parentAddItemSaveHandler: addItemSaveHandler,
            parentEditItemSaveHandler: editItemSaveHandler,
            parentRemoveItemHandler: removeItemHandler,
            addressFormatter : addressFormatterForFarmLand,
            resetChosenTermAndChosenTermValue,
            formatOptionAvailableVals
        },
        hoSeparateStructsNotRented: {
            visible: !_.isUndefined(separateStructsNotRented),
            schedItemType: SEPARATE_STRUCTS_NOT_RENTED_TYPE,
            items: separateStructsNotRented,
            defaultItem: defaultSeparateStructsNotRented,
            readOnly,
            loading,
            parentAddItemSaveHandler: addItemSaveHandler,
            parentEditItemSaveHandler: editItemSaveHandler,
            parentRemoveItemHandler: removeItemHandler,
            addressFormatter : addressFormatterForFarmLand,
            resetChosenTermAndChosenTermValue,
            formatOptionAvailableVals
        },
        hoSeparateStructsRented: {
            visible: !_.isUndefined(separateStructsRented),
            schedItemType: SEPARATE_STRUCTS_RENTED_TYPE,
            items: separateStructsRented,
            defaultItem: defaultSeparateStructsRented,
            readOnly,
            loading,
            parentAddItemSaveHandler: addItemSaveHandler,
            parentEditItemSaveHandler: editItemSaveHandler,
            parentRemoveItemHandler: removeItemHandler,
            addressFormatter : addressFormatterForFarmLand,
            resetChosenTermAndChosenTermValue,
            formatOptionAvailableVals
        },
        hoSeparateStructsAwayFromResidence: {
            visible: !_.isUndefined(separateStructsAwayFromResidence),
            schedItemType: SEPARATE_STRUCTS_AWAY_FROM_RESIDENCE_TYPE,
            items: separateStructsAwayFromResidence,
            defaultItem: defaultSeparateStructsAwayFromResidence,
            readOnly,
            loading,
            parentAddItemSaveHandler: addItemSaveHandler,
            parentEditItemSaveHandler: editItemSaveHandler,
            parentRemoveItemHandler: removeItemHandler,
            addressFormatter : addressFormatterForFarmLand,
            resetChosenTermAndChosenTermValue,
            formatOptionAvailableVals
        },
        hoValuableItemsSpecified: {
            visible: !_.isUndefined(valuableItemsSpecified),
            schedItemType: VALUABLE_ITEMS_SPECIFIED_TYPE,
            items: valuableItemsSpecified,
            defaultItem: defaultValuableItemsSpecified,
            readOnly,
            loading,
            parentAddItemSaveHandler: addItemSaveHandler,
            parentEditItemSaveHandler: editItemSaveHandler,
            parentRemoveItemHandler: removeItemHandler,
            resetChosenTermAndChosenTermValue,
            onCovChange
        },
        hoSeparateStructureExclusion: {
            visible: !_.isUndefined(separateStructureExclusionItems),
            schedItemType: SEPARATE_STRUCTURE_EXCLUSION_TYPE,
            items: separateStructureExclusionItems,
            defaultItem: defaultSeparateStructureExclusion,
            readOnly,
            loading,
            parentAddItemSaveHandler: addItemSaveHandler,
            parentEditItemSaveHandler: editItemSaveHandler,
            parentRemoveItemHandler: removeItemHandler,
            addressFormatter: addressFormatterTermState,
            resetChosenTermAndChosenTermValue,
            formatOptionAvailableVals
        },
        hoOtherStructureExclusion: {
            visible: !_.isUndefined(otherStructureExclusionItems),
            schedItemType: OTHER_STRUCTURE_EXCLUSION_TYPE,
            items: otherStructureExclusionItems,
            defaultItem: defaultOtherStructureExclusion,
            readOnly,
            loading,
            parentAddItemSaveHandler: addItemSaveHandler,
            parentEditItemSaveHandler: editItemSaveHandler,
            parentRemoveItemHandler: removeItemHandler,
            addressFormatter: addressFormatterTermState,
            resetChosenTermAndChosenTermValue,
            formatOptionAvailableVals
        },
        pupAnimalLiability: {
            visible: !_.isUndefined(pupAnimalLiabilityExclusions),
            items: pupAnimalLiabilityExclusions,
            readOnly,
            getTypeKeyDescription,
            getYesNoAnswer
        },
        pupExcludedLocation: {
            visible: !_.isUndefined(pupExcludedLocations) && readOnly,
            items: pupExcludedLocations,
            getTypeKeyDescription,
            getYesNoAnswer
        },
        pupBusinessActivites: {
            visible: !_.isUndefined(pupBusinessActivities) && readOnly,
            items: pupBusinessActivities,
            getTypeKeyDescription,
            isModernProduct
        },
        pupExcludedWatercraftsComponent: {
            visible: !_.isUndefined(pupExcludedWatercrafts) && readOnly,
            items: pupExcludedWatercrafts,
            getTypeKeyDescription,
            getYesNoAnswer
        }
    };

    return (
        <MetadataContent
            uiProps={metadata.componentContent}
            overrideProps={overrides}
            {...resolvers} />
    );
}

MLClauseScheduledItemsComponent.propTypes = {
    clause: PropTypes.shape({}),
    onCovChange: PropTypes.func,
    onGeneralChange: PropTypes.func,
    loading: PropTypes.bool,
    readOnly: PropTypes.bool
};

export default MLClauseScheduledItemsComponent;
